import { ContentControlledEditingDirectiveViewModel } from './content-controlled-editing-directive-view-model';
import { SegmentExtenderKeyframe } from './segment-extender-keyframe';

export class SegmentExtender {
  constructor(
    public id: number,
    public item: ContentControlledEditingDirectiveViewModel,
    public width: number,
    public height: number,
    public keyframes: SegmentExtenderKeyframe[],
    public left: number,
    public style: Partial<CSSStyleDeclaration>,
  ) {}
}
